import React from "react";
import {styled} from "@mui/material/styles";
import {DataGridPro, DataGridProProps, gridClasses} from "@mui/x-data-grid-pro";

const StripedDataGridComponent = styled(DataGridPro)(({ theme }) => ({
	[`& .${gridClasses.row}.even:not(:hover)`]: {
		backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.04)" : "rgba(255, 255, 255, 0.04)",
	},
	[`& .${gridClasses.row}.even:hover`]: {
		backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.08)",
	},
}));

type StripedDataGridProps = DataGridProProps<any> & React.RefAttributes<HTMLDivElement>;

export function StripedDataGrid(
	props: StripedDataGridProps
) {
	return <StripedDataGridComponent
		{...props}
		getRowClassName={(params) => {
			const baseClass = props.getRowClassName && props.getRowClassName(params);
			const classPrefix = baseClass ? baseClass + " " : "";
			const rowClass = params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
			return classPrefix + rowClass;
		}}
	/>;
}
